import { useQuery } from '@tanstack/react-query';
import { countryApi } from '../api/country.api';
import { countryKeys } from '../api/country.keys';
import type { Country } from '@/shared/types';

export function useCountryDetails(id: string | number | undefined) {
  return useQuery<Country>({
    queryKey: countryKeys.detail(id!),
    queryFn: () => countryApi.getById(id!),
    enabled: !!id,
  });
}
